import { useCallback } from "react";
import { ref, set, remove } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";
import { useNavigate } from "react-router";
import uuid from "react-uuid";

const useKilnActions = () => {
  const { effectiveUID } = useAuth();
  const navigate = useNavigate();

  const userPath = () => `/userdata/${effectiveUID}`;

  const createKiln = useCallback(
    (formProps: any) => {
      formProps.id = uuid();
      set(ref(db, userPath() + `/kilns/${formProps.id}`), {
        ...formProps,
      });
      navigate(-1);
    },
    [effectiveUID, navigate]
  );

  const editKiln = useCallback(
    (id: string, formProps: any) => {
      formProps.id = id;
      set(ref(db, userPath() + `/kilns/${id}`), {
        ...formProps,
      });
      navigate(-1);
    },
    [effectiveUID, navigate]
  );

  const deleteKiln = useCallback(
    (id: string) => {
      remove(ref(db, userPath() + `/kilns/${id}`));
      navigate("/kilns");
    },
    [effectiveUID, navigate]
  );

  return { createKiln, editKiln, deleteKiln };
};

export default useKilnActions;
